
import { defineComponent, onMounted, ref } from "vue";
import PackagePointsList from "@/components/packagepoints/PackagePointsList.vue";

export default defineComponent({
  name: "packagepoints",
  components: {
    PackagePointsList
  },
  setup() {
    const tabIndex = ref(0);

   

    onMounted(() => {
      // set the tab from previous
      tabIndex.value = parseInt(localStorage.getItem("packagepointsTab") || "0");
    });

  }
});
